import "./AppointmentListingCard.css";
import React from "react";

const AppointmentListingCard = ({ appointment }) => {
  return (
    <div className="appointment-listing-card">
      <div className="client-and-type">
        <div className="client">
          <svg
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23 8.896V17.104C23 18.448 22.2735 19.696 21.0991 20.38L13.907 24.496C12.7325 25.168 11.2796 25.168 10.093 24.496L2.90094 20.38C2.32191 20.0473 1.84142 19.5694 1.50775 18.9943C1.17407 18.4193 0.998961 17.7674 1 17.104V8.896C1 7.552 1.72648 6.304 2.90094 5.62L10.093 1.504C11.2675 0.832 12.7204 0.832 13.907 1.504L21.0991 5.62C22.2735 6.304 23 7.54 23 8.896Z"
              stroke="#4C3CA6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.3977 18.4522C16.3977 16.1689 14.4287 14.3169 11.9977 14.3169C9.56666 14.3169 7.59766 16.1689 7.59766 18.4522M11.9977 11.2725C12.6774 11.2725 13.3293 10.9611 13.81 10.4069C14.2906 9.85258 14.5607 9.10081 14.5607 8.31693C14.5607 7.53306 14.2906 6.78129 13.81 6.227C13.3293 5.67272 12.6774 5.36133 11.9977 5.36133C11.3179 5.36133 10.666 5.67272 10.1853 6.227C9.70469 6.78129 9.43466 7.53306 9.43466 8.31693C9.43466 9.10081 9.70469 9.85258 10.1853 10.4069C10.666 10.9611 11.3179 11.2725 11.9977 11.2725V11.2725Z"
              stroke="#4C3CA6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className="name">{appointment?.clientObject?.name}</div>
        </div>
        {appointment.type === "meeting" ? (
          <div className="type">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
                stroke="#C5C5C5"
                strokeWidth="0.5"
              />
              <path
                d="M17.4298 11.9388V12.4223C17.4298 14.3557 16.9464 14.8337 15.0183 14.8337H8.97885C7.05075 14.8337 6.56738 14.3503 6.56738 12.4223V8.97885C6.56738 7.05075 7.05075 6.56738 8.97885 6.56738H9.82612M11.9986 14.8337V17.4298M6.56738 12.5417H17.4298M9.55453 17.4298H14.4426"
                stroke="#808080"
                strokeWidth="0.5"
              />
              <path
                d="M15.1803 10.5721H12.595C11.8456 10.5721 11.5957 10.0724 11.5957 9.57272V7.66097C11.5957 7.06351 12.0845 6.57471 12.682 6.57471H15.1803C15.7343 6.57471 16.1797 7.02009 16.1797 7.57405V9.57272C16.1797 10.1267 15.7343 10.5721 15.1803 10.5721ZM16.8368 9.78455L16.1797 9.32291V7.8239L16.8368 7.36222C17.1627 7.13957 17.4288 7.27534 17.4288 7.67183V9.48041C17.4288 9.87691 17.1627 10.0127 16.8368 9.78455Z"
                stroke="#808080"
                strokeWidth="0.5"
              />
            </svg>

            <div className="title">Online Meeting</div>
          </div>
        ) : appointment.type === "call" ? (
          <div className="type">
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 22.5C17.5751 22.5 22.5 17.5751 22.5 11.5C22.5 5.42487 17.5751 0.5 11.5 0.5C5.42487 0.5 0.5 5.42487 0.5 11.5C0.5 17.5751 5.42487 22.5 11.5 22.5Z"
                stroke="#C5C5C5"
                strokeWidth="0.5"
              />
              <path
                d="M16.7944 15.4307C16.7944 15.6371 16.7485 15.8492 16.6511 16.0556C16.5536 16.262 16.4275 16.4569 16.2612 16.6404C15.9803 16.95 15.6707 17.1735 15.321 17.3169C14.977 17.4602 14.6044 17.5348 14.2031 17.5348C13.6183 17.5348 12.9934 17.3971 12.3342 17.1162C11.6749 16.8353 11.0156 16.4569 10.362 15.9811C9.69591 15.4939 9.06734 14.9573 8.4816 14.3759C7.90188 13.7923 7.36719 13.1656 6.88211 12.5012C6.41203 11.8477 6.03367 11.1941 5.75845 10.5463C5.48327 9.89272 5.3457 9.26783 5.3457 8.67163C5.3457 8.28178 5.41449 7.90913 5.5521 7.56516C5.68967 7.21545 5.90751 6.89439 6.21138 6.60776C6.57829 6.2466 6.97959 6.06885 7.40383 6.06885C7.56434 6.06885 7.72489 6.10324 7.86821 6.17207C8.01727 6.24085 8.14909 6.34403 8.25231 6.49309L9.58232 8.36776C9.68554 8.51107 9.76007 8.64294 9.81166 8.76906C9.86325 8.88947 9.89194 9.00984 9.89194 9.11877C9.89194 9.25638 9.8518 9.39395 9.77152 9.52581C9.69699 9.65768 9.58807 9.79529 9.4505 9.93286L9.01476 10.3858C8.95173 10.4488 8.92304 10.5234 8.92304 10.6151C8.92304 10.661 8.92879 10.7011 8.94023 10.7469C8.95743 10.7928 8.97467 10.8272 8.98612 10.8616C9.0893 11.0508 9.26705 11.2973 9.51928 11.5954C9.77727 11.8935 10.0524 12.1974 10.3506 12.5012C10.6601 12.8051 10.9583 13.086 11.2621 13.344C11.5602 13.5962 11.8067 13.7682 12.0016 13.8714C12.0303 13.8828 12.0647 13.9 12.1048 13.9172C12.1507 13.9344 12.1965 13.9402 12.2481 13.9402C12.3456 13.9402 12.4201 13.9058 12.4832 13.8427L12.9189 13.4128C13.0622 13.2694 13.1998 13.1605 13.3317 13.0917C13.4635 13.0115 13.5954 12.9713 13.7387 12.9713C13.8476 12.9713 13.9623 12.9943 14.0884 13.0459C14.2146 13.0974 14.3464 13.172 14.4898 13.2694L16.3873 14.6167C16.5364 14.7199 16.6396 14.8402 16.7026 14.9836C16.76 15.1269 16.7944 15.2702 16.7944 15.4307Z"
                stroke="#808080"
                strokeWidth="0.5"
              />
              <path
                d="M14.8044 10.0819C14.8044 9.73795 14.535 9.21049 14.1336 8.78055C13.7667 8.38495 13.2794 8.07538 12.7979 8.07538M16.8109 10.0819C16.8109 7.86328 15.0165 6.06885 12.7979 6.06885"
                stroke="#808080"
                strokeWidth="0.5"
              />
            </svg>

            <div className="title">Call</div>
          </div>
        ) : appointment.type === "message" ? (
          <div className="type">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
                stroke="#C5C5C5"
                strokeWidth="0.5"
              />
              <path
                d="M16.713 12.0017V13.0276C16.713 14.9285 15.6268 15.7432 13.9974 15.7432H8.56619C6.93685 15.7432 5.85059 14.9285 5.85059 13.0276V9.76883C5.85059 7.8679 6.93685 7.05322 8.56619 7.05322H10.1956C10.1171 7.28256 10.0749 7.53601 10.0749 7.80755V10.1611C10.0749 10.7464 10.268 11.2413 10.612 11.5853C10.9559 11.9292 11.4508 12.1223 12.0361 12.1223V12.9612C12.0361 13.2689 12.3862 13.456 12.6456 13.287L14.3896 12.1223H15.9587C16.2302 12.1223 16.4837 12.0801 16.713 12.0017Z"
                stroke="#808080"
                strokeWidth="0.5"
              />
              <path
                d="M9.1123 17.9122H13.4573M11.2848 15.7396V17.9122M17.9229 7.80405V10.1576C17.9229 11.0567 17.4643 11.7326 16.716 11.9981C16.4867 12.0766 16.2332 12.1188 15.9617 12.1188H14.3926L12.6486 13.2835C12.3891 13.4525 12.0391 13.2654 12.0391 12.9577V12.1188C11.4537 12.1188 10.9589 11.9257 10.6149 11.5818C10.2709 11.2378 10.0778 10.7429 10.0778 10.1576V7.80405C10.0778 7.53251 10.1201 7.27906 10.1985 7.04972C10.464 6.30141 11.1399 5.84277 12.0391 5.84277H15.9617C17.1384 5.84277 17.9229 6.62728 17.9229 7.80405Z"
                stroke="#808080"
                strokeWidth="0.5"
              />
              <path
                d="M14.9688 9.30615H14.9717M14.158 9.30615H14.1606M13.3467 9.30615H13.3496"
                stroke="#808080"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className="title">Message</div>
          </div>
        ) : appointment.type === "email" ? (
          <div className="type">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
                stroke="#C5C5C5"
                strokeWidth="0.5"
              />
              <path
                d="M15.0787 17.033H8.92337C7.07676 17.033 5.8457 16.1097 5.8457 13.9553V9.64656C5.8457 7.49217 7.07676 6.56885 8.92337 6.56885H15.0787C16.9254 6.56885 18.1564 7.49217 18.1564 9.64656V13.9553C18.1564 16.1097 16.9254 17.033 15.0787 17.033Z"
                stroke="#808080"
                strokeWidth="0.5"
              />
              <path
                d="M15.0782 9.95459L13.1516 11.4935C12.5176 11.9982 11.4773 11.9982 10.8433 11.4935L8.92285 9.95459"
                stroke="#808080"
                strokeWidth="0.5"
              />
            </svg>

            <div className="title">Email</div>
          </div>
        ) : appointment.type === "task" ? (
          <div className="type">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
                stroke="#C5C5C5"
                strokeWidth="0.5"
              />
              <path
                d="M9.58594 12.0001H13.8102M9.58594 14.4139H12.2291M10.7929 8.25862H13.2068C14.4137 8.25862 14.4137 7.65515 14.4137 7.05167C14.4137 5.84473 13.8102 5.84473 13.2068 5.84473H10.7929C10.1894 5.84473 9.58594 5.84473 9.58594 7.05167C9.58594 8.25862 10.1894 8.25862 10.7929 8.25862Z"
                stroke="#808080"
                strokeWidth="0.5"
              />
              <path
                d="M14.4134 7.06299C16.423 7.1716 17.4308 7.91389 17.4308 10.6717V14.2925C17.4308 16.7064 16.8273 17.9133 13.81 17.9133H10.1892C7.17183 17.9133 6.56836 16.7064 6.56836 14.2925V10.6717C6.56836 7.91991 7.57614 7.1716 9.58573 7.06299"
                stroke="#808080"
                strokeWidth="0.5"
              />
            </svg>

            <div className="title">Task</div>
          </div>
        ) : (
          ""
        )}
      </div>

      {appointment?.dealObject?.property?.propertyTitle && (
        <div className="deal">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 0V1.42737L6 2.26737V1.26316H11V10.7368H8.5V12H12V0H5ZM3.75 1.89474L0 5.05263V12H7.5V5.05263L3.75 1.89474ZM7 2.52632V3.11368L7.805 3.78947H8V2.52632H7ZM9 2.52632V3.78947H10V2.52632H9ZM3.75 3.47368L6.5 5.68421V10.7368H5V6.94737H2.5V10.7368H1V5.68421L3.75 3.47368ZM9 5.05263V6.31579H10V5.05263H9ZM9 7.57895V8.8421H10V7.57895H9Z"
              fill="#808080"
            />
          </svg>

          <div className="property">
            {appointment?.dealObject?.property?.propertyTitle}
          </div>
        </div>
      )}

      <div className="appointment-time">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 7C13 10.312 10.312 13 7 13C3.688 13 1 10.312 1 7C1 3.688 3.688 1 7 1C10.312 1 13 3.688 13 7Z"
            stroke="#808080"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.00065 8.9974L6.97451 7.711C6.62157 7.48849 6.33398 6.95307 6.33398 6.515V3.66406"
            stroke="#808080"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <div className="time">
          {appointment?.startTime} - {appointment?.endTime}
        </div>
      </div>
    </div>
  );
};

export default AppointmentListingCard;
